export default "__VITE_ASSET__BgiruQCD__"